
export var PAGE_TITLE_LABEL_KEY = 'PREVIOUS_OFFERINGS';

export var PRINT_ICON_LABEL = 'Print';
export var EMAIL_ICON_LABEL = 'Email';
export var NOTIFICTION_ICON_LABEL = 'Notification';

export var RESULTS_PAGE_SIZE = 20;
